/* ZoomyMoo – interactions (GSAP + vanilla) */
(function () {
  'use strict';
  var root = document.querySelector('[data-zm-root]');
  if (!root) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ── GSAP entrance + ScrollTrigger reveals ── */
  function initGsap() {
    if (!window.gsap) return;
    document.documentElement.classList.add('zm-js');
    if (reduce) return;
    if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

    gsap.from('.zm-hero__stage', { scale: .85, opacity: 0, duration: .8, ease: 'back.out(1.6)' });
    gsap.from('.zm-hero__info > *', { y: 24, opacity: 0, duration: .6, stagger: .07, ease: 'power3.out', delay: .15 });
    gsap.from('.zm-sticker', { scale: 0, rotation: -40, duration: .7, stagger: .15, ease: 'back.out(2.2)', delay: .5, clearProps: 'transform' });

    gsap.utils.toArray('[data-zm-reveal]').forEach(function (el) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: .9, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 85%', once: true }
      });
      var kids = el.querySelectorAll('.zm-demo__card, .zm-benefit, .zm-gift__chips li');
      if (kids.length) {
        gsap.from(kids, {
          y: 40, opacity: 0, scale: .94, duration: .7, stagger: .12, ease: 'back.out(1.5)',
          scrollTrigger: { trigger: el, start: 'top 80%', once: true }, clearProps: 'transform'
        });
      }
    });
  }
  if (window.gsap) initGsap(); else window.addEventListener('load', initGsap);

  /* ── Gallery thumbnails ── */
  var main = root.querySelector('[data-zm-main]');
  root.querySelectorAll('[data-zm-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      root.querySelectorAll('[data-zm-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      main.classList.add('is-swapping');
      setTimeout(function () {
        main.removeAttribute('srcset');
        main.src = btn.getAttribute('data-zm-thumb');
        main.onload = function () { main.classList.remove('is-swapping'); };
        setTimeout(function () { main.classList.remove('is-swapping'); }, 400);
      }, 180);
    });
  });

  /* ── Variant price ── */
  var variantSelect = root.querySelector('[data-zm-variant]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      root.querySelectorAll('[data-zm-price]').forEach(function (el) { el.textContent = opt.getAttribute('data-price'); });
    });
  }

      var img = opt.getAttribute('data-image');
      if (img && main) {
        root.querySelectorAll('[data-zm-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-zm-thumb') === img);
        });
        main.classList.add('is-swapping');
        setTimeout(function () {
          main.removeAttribute('srcset');
          main.src = img;
          main.onload = function () { main.classList.remove('is-swapping'); };
          setTimeout(function () { main.classList.remove('is-swapping'); }, 400);
        }, 180);
      }
  /* ── Cart ── */
  var form = document.getElementById('zm-form');
  var cta = root.querySelector('[data-zm-cta]');
  var errorEl = root.querySelector('[data-zm-error]');
  var toast = root.querySelector('[data-zm-toast]');

  function updateCount() {
    return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-zm-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
        });
      }).catch(function () {});
  }

  function addToCart() {
    var data = new FormData(form);
    return fetch(cartRoot + 'cart/add.js', {
      method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) throw new Error(json.description || json.message || 'Nu am putut adăuga produsul.');
        return json;
      });
    });
  }

  function confetti(x, y) {
    if (reduce || !window.gsap) return;
    var colors = ['#22E36B', '#FF9EC0', '#FFD43B', '#E8323C', '#FFFFFF'];
    for (var i = 0; i < 26; i++) {
      var c = document.createElement('span');
      c.className = 'zm-confetti';
      c.style.left = x + 'px'; c.style.top = y + 'px';
      c.style.background = colors[i % colors.length];
      document.body.appendChild(c);
      gsap.to(c, {
        x: gsap.utils.random(-170, 170), y: gsap.utils.random(-260, -60), rotation: gsap.utils.random(-540, 540),
        duration: gsap.utils.random(.6, 1), ease: 'power2.out',
        onComplete: (function (el) {
          return function () { gsap.to(el, { y: '+=220', opacity: 0, duration: .7, ease: 'power1.in', onComplete: function () { el.remove(); } }); };
        })(c)
      });
    }
  }

  function showToast() {
    if (!toast) return;
    toast.hidden = false;
    if (window.gsap && !reduce) gsap.fromTo(toast, { y: -30, opacity: 0, scale: .9 }, { y: 0, opacity: 1, scale: 1, duration: .5, ease: 'back.out(2)' });
    clearTimeout(showToast.t);
    showToast.t = setTimeout(function () { toast.hidden = true; }, 7000);
  }
  var toastClose = root.querySelector('[data-zm-toast-close]');
  if (toastClose) toastClose.addEventListener('click', function () { toast.hidden = true; });

  function setError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  if (form && cta) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setError('');
      cta.classList.add('is-loading'); cta.setAttribute('aria-busy', 'true');
      addToCart().then(function () {
        var r = cta.getBoundingClientRect();
        confetti(r.left + r.width / 2, r.top + r.height / 2);
        updateCount();
        showToast();
      }).catch(function (err) { setError(err.message); })
        .finally(function () { cta.classList.remove('is-loading'); cta.removeAttribute('aria-busy'); });
    });
  }

  var buyNow = root.querySelector('[data-zm-buynow]');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      if (!form) { window.location.href = cartRoot + 'collections/all'; return; }
      buyNow.disabled = true; buyNow.textContent = 'Se încarcă…';
      addToCart().then(function () { window.location.href = cartRoot + 'checkout'; })
        .catch(function (err) {
          buyNow.disabled = false; buyNow.textContent = 'Cumpără Acum';
          setError(err.message); cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    });
  }

  /* ── Sticky bar: show once the hero CTA has scrolled off the top ── */
  var sticky = root.querySelector('[data-zm-sticky]');
  if (sticky && cta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (buyNow) buyNow.tabIndex = show ? 0 : -1;
    }, { threshold: 0 }).observe(cta);
  }

  /* ── 15% newsletter popup ── */
  var popup = root.querySelector('[data-zm-popup]');
  if (popup) {
    var box = popup.querySelector('.zm-popup__box');
    var success = popup.querySelector('[data-zm-popup-success]') || /customer_posted=true/.test(location.search);
    var lastFocus = null;

    var open = function () {
      if (!popup.hidden) return;
      lastFocus = document.activeElement;
      popup.hidden = false;
      store.set('zm_popup_seen', '1');
      if (window.gsap && !reduce) {
        gsap.fromTo(popup.querySelector('.zm-popup__backdrop'), { opacity: 0 }, { opacity: 1, duration: .3 });
        gsap.fromTo(box, { y: 60, scale: .7, rotation: -6, opacity: 0 }, { y: 0, scale: 1, rotation: 0, opacity: 1, duration: .7, ease: 'elastic.out(1, .6)' });
      }
      var f = popup.querySelector('input[type=email], [data-zm-copy]');
      if (f) setTimeout(function () { f.focus(); }, 120);
    };
    var close = function () {
      popup.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    popup.querySelectorAll('[data-zm-popup-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });

    if (success) {
      open();
    } else if (!store.get('zm_popup_seen')) {
      var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 8) * 1000;
      var timer = setTimeout(open, delay);
      document.addEventListener('mouseout', function onLeave(e) {
        if (!e.relatedTarget && e.clientY < 10) { clearTimeout(timer); open(); document.removeEventListener('mouseout', onLeave); }
      });
    }

    var copyBtn = popup.querySelector('[data-zm-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-zm-copy');
        var label = copyBtn.querySelector('[data-zm-copy-label]');
        var done = function () { if (label) label.textContent = 'Copiat ✓'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    }
  }
})();
